import { FormItemContainer } from '@/components'
import { Form, Input, Button, Image, Checkbox, Typography } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { CommonProps } from './index'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { addToken, setChoiceOrg, setPrivatize, setUserInfo, updateRole } from '@/redux/userSlice'
import { useVerify, useAgreement, useSubLogin, useUserSubInfo } from './util'
import Protocol from './protocol'
import { useEffect, useState } from 'react'
import { t } from '@/i18n'

const { useForm } = Form

interface SubAccountProps extends CommonProps {}

export const SubAccount = (props: SubAccountProps) => {
  const { setLoginStatus, loginType } = props
  const [form] = useForm()
  //是否是首次登录
  const [firstLoginStatus, setFirstLoginStatus] = useState(false)
  let [visible, setVisible] = useState({ visibleShow: false, data: null })
  const [protocolTab, setProtocolTab] = useState<'privacy' | 'service'>(null)
  let [base, setBase] = useState({ base64: '', verify_token: '' })
  const [agreementOff, setAgreementOff] = useState(false)
  const [loginLoading, setLoginLoading] = useState(false)
  const [login] = useSubLogin()
  const [verify] = useVerify()
  let [datas, setDatas] = useState<any>()
  const consent = consented => {
    if (consented) {
      dispatch(addToken(JSON.stringify({ id: datas.ID, token: datas.token, loginType })))
      return
    }
    setVisible({ visibleShow: false, data: null })
    setDatas((datas = null))
  }
  let [enter, setEnter] = useState(true)
  let [show, setShow] = useState(false)
  const [agreement] = useAgreement()
  const [userInfo, getUserInfo, infoLoading] = useUserSubInfo()
  const loginHandler = async (values: any) => {
    try {
      const { username, password, verify, agree } = values
      if (!agree && agreementOff) {
        setProtocol(true)
        setTimeout(() => {
          setProtocol((protocol = false))
        }, 800)
        return
      }
      setLoginLoading(true)
      const { data } = await login({
        username: username.replace(/\s*/g, ''),
        // password: `${username.replace(/\s*/g, '')} ${password}`,
        password,
        verify_token: base?.verify_token,
        verify: verify,
      })
      dispatch(setPrivatize(data?.privatization))
      if (data?.first_login === 1) {
        console.log(111)

        localStorage.setItem(
          'subToken',
          JSON.stringify({ id: data.ID ? data.ID : data.id, token: data.token }),
        )
        localStorage.setItem('login-id', data.ID ? data.ID : data.id)
        setLoginLoading(false)
        return setFirstLoginStatus(true)
      }
      document.cookie = `${'protocol'}; max-age=${30 * 24 * 60 * 60}`
      setEnter(false)
      console.log('data', data)
      if (data.agreement) {
        dispatch(
          addToken(
            JSON.stringify({ id: data.ID ? data.ID : data.id, token: data.token, loginType }),
          ),
        )
        setEnter(false)
        return
      }
      agreement({ token: data?.token, user_id: data?.ID ? data.ID : data.id })
        .then(res => {
          localStorage.setItem('subToken', JSON.stringify(data))
        })
        .catch(err => {})
      getUserInfo()
        .catch(() => {})
        .then((r: any) => {
          localStorage.setItem(
            'info',
            unescape(window.atob(window.btoa(escape(JSON.stringify(r?.data))))) == 'undefined'
              ? window.btoa(escape(JSON.stringify({})))
              : window.btoa(escape(JSON.stringify(r?.data))),
          )
          localStorage.setItem('roleType', r?.data?.user_data?.role?.role_header.role_name || '')
          dispatch(setUserInfo(r?.data))
          dispatch(
            updateRole(r?.data?.email ? '主账号' : r?.data?.user_data?.role?.role_header.role_name),
          )
        })
      dispatch(setChoiceOrg([]))
      setLoginLoading(false)
      dispatch(
        addToken(JSON.stringify({ id: data.ID ? data.ID : data.id, token: data.token, loginType })),
      )
      setDatas((datas = data))
    } catch (error: any) {
      setLoginLoading(false)
      form!.setFieldsValue({ verify: '' })
      if (error.msg === '验证码为空' || error?.err_count === 3) {
        setShow((show = true))
      }
      if (show) {
        verification()
      }
    }
  }
  const verification = () => {
    verify({ verify_type: 'login' })
      .then(res => {
        setBase((base = res.data))
      })
      .catch(err => {})
  }

  document.onkeydown = e => {
    if (enter) {
      e.key === 'Enter' ? form.submit() : ''
    }
  }
  const dispatch = useDispatch()
  const toForgetPwd = () => {
    setEnter((enter = false))
    setLoginStatus('forget-pwd')
  }
  let [protocol, setProtocol] = useState(false)
  useEffect(() => {
    agreement({
      token: undefined,
      user_id: undefined,
    })
      .then(res => {
        setAgreementOff(res?.data?.on_off === 1)
        // setAgreementOff(false)
      })
      .catch(() => {})
  }, [])
  const toFirstLogin = () => {
    setEnter((enter = false))
    setLoginStatus('first-login')
  }
  return (
    <Direct>
      <Protocol visible={visible} consent={consent} protocolTab={protocolTab} />
      <Form
        form={form}
        onFinish={loginHandler}
        initialValues={{ agree: document.cookie.split(';').some(e => e === 'protocol') }}
      >
        <FormItemContainer>
          <Form.Item
            name="username"
            rules={[{ required: true, message: t('请输入子账号') }]}
            getValueFromEvent={e => e.target.value.replace(/\s+/g, '')}
          >
            <Input
              prefix={<UserOutlined style={{ color: '#333333' }} />}
              placeholder={t('<子账号用户名称>@<母账号域地址>.example<账号ID>.com')}
              maxLength={120}
            />
          </Form.Item>
        </FormItemContainer>
        <div className="tip">{t('例如：username@company.example123456781.com')}</div>
        <FormItemContainer>
          <Form.Item name={'password'} rules={[{ required: true, message: t('请输入子账号密码') }]}>
            <Input.Password
              prefix={<LockOutlined style={{ color: '#333333' }} />}
              placeholder={t('请输入子账号密码')}
              maxLength={120}
              onKeyDown={e => {
                e.key === 'Enter' ? form.submit() : ''
              }}
            />
          </Form.Item>
        </FormItemContainer>
        <div className="tip" style={{ marginBottom: 36 }}>
          {t('如果您忘记密码，请联系主账号重置密码')}
        </div>
        {show && (
          <FormItemContainer>
            <div style={{ display: 'flex' }}>
              <Form.Item
                name={'verify'}
                rules={[{ required: true, message: t('请输入验证码') }]}
                style={{ width: '70%', marginRight: '10px' }}
              >
                <Input placeholder={t('请输入验证码')} />
              </Form.Item>
              <div
                style={{ width: '30%', borderRadius: '4px', overflow: 'hidden', height: '32px' }}
              >
                <Image
                  height={'32px'}
                  src={`data:image/png;base64,${base?.base64}`}
                  preview={false}
                  onClick={() => verification()}
                />
              </div>
            </div>
          </FormItemContainer>
        )}
        <LoginBtnContainer>
          <BlockButton
            block
            className="loginBtn"
            loading={loginLoading}
            type={'primary'}
            onClick={form.submit}
          >
            {t('登录')}
          </BlockButton>
          <div style={{ display: firstLoginStatus ? 'block' : 'none' }} className="first">
            {t('首次登录，请重置密码再登录')}
            <Typography.Link onClick={() => toFirstLogin()} className="changePwd">
              {t('重置密码')}
            </Typography.Link>
          </div>
        </LoginBtnContainer>
        {agreementOff && (
          <AgreementDiv>
            <Form.Item
              name={'agree'}
              style={{ marginTop: 40 }}
              className={protocol && 'shake'}
              valuePropName="checked"
            >
              <Checkbox>
                <span style={{ color: '#333333' }}>
                  {t('我已阅读并同意')}
                  <span
                    className="protocol"
                    onClick={e => {
                      e.preventDefault()
                      setVisible({ visibleShow: true, data: null })
                      setProtocolTab('privacy')
                    }}
                  >
                    {t('隐私政策')}
                  </span>
                  {t('和')}
                  <span
                    className="protocol"
                    onClick={e => {
                      e.preventDefault()
                      setVisible({ visibleShow: true, data: null })
                      setProtocolTab('service')
                    }}
                  >
                    {t('服务协议')}
                  </span>
                </span>
              </Checkbox>
            </Form.Item>
          </AgreementDiv>
        )}
      </Form>
    </Direct>
  )
}

const LoginBtnContainer = styled.div`
  margin-top: 5px;
  position: relative;
  border: 1px solid #4238c9;
  border-radius: 6px;
  background: #4238c9;
  &:hover {
    background: linear-gradient(320deg, #675fd3 0%, #4238c9 100%);
  }
  .first {
    position: absolute;
    right: 0;
    top: -27px;
    color: #666666;
    .changePwd {
      color: #807ddb;
      margin-left: 6px;
    }
  }
  .retrieve {
    position: absolute;
    right: 0;
    top: -16px;
    color: #666666;
    // &:hover {
    //   color: #4238c9;
    // }
    /* font-size: 12px; */
  }
  .ant-btn-primary {
    background: #4238c9;
    border: 1px solid #4238c9;
  }
`
const AgreementDiv = styled.div`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #4238c9;
    border-color: #4238c9;
  }
  .ant-checkbox-checked::after {
    border-color: #4238c9;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #4238c9;
  }

  input#agree {
    border-color: #4238c9;
  }
`
const Direct = styled.div`
  .ant-input-affix-wrapper,
  .ant-input {
    border-color: #d9d9d9;
    &:hover {
      border-color: #4238c9;
    }
  }
  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    background-image: none;
    transition: background-color 50000s ease-in-out 0s;
  }
  .ant-input-affix-wrapper {
    height: 36px;
  }
  .protocol {
    cursor: pointer;
    color: #4238c9;
    &:hover {
      color: #807ddb;
    }
  }
  .shake {
    transform-style: preserve-3d;
    animation: shake 800ms ease-in-out;
  }
  .tip {
    margin-top: -16px !important;
    margin-bottom: 24px !important;
    color: #666666;
  }
  @keyframes shake {
    10%,
    90% {
      transform: rotate(2deg);
    }
    20%,
    80% {
      transform: rotate(-2deg);
    }
    30%,
    70% {
      transform: rotate(2deg);
    }
    40%,
    60% {
      transform: rotate(-2deg);
    }
    50% {
      transform: rotate(2deg);
    }
  }
`

export const BlockButton = styled(Button)`
  height: 38px;
  font-size: 16px;
  background: #4238c9;
  border-radius: 6px;
  &::after {
    display: none;
  }
  &:hover {
    background: linear-gradient(320deg, #4238c9 0%, #675fd3 100%);
    border: none;
  }
`
